import { useOutletContext } from "react-router-dom";
import {
  Box,
  CircularProgress,
  Divider,
  Typography,
  styled,
} from "@mui/material";
import { useBusinessKyc } from "@/hooks/use-business-kyc";
import KycBusinessInfo from "../_components/kyc-business-info";
import KycContact from "../_components/kyc-contact";
import KycOnline from "../_components/kyc-online";
import KycBusinessAccount from "../_components/kyc-business-account";
import KycDocuments from "../_components/kyc-documents";
import KycDirectorInfo from "../_components/kyc-director-info";
import { CustomErrorMessage } from "@/components/custom/custom-error-message";

const SectionRoot = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
}));

const Card = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: "16px 20px",
  borderRadius: "12px",
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const Kyc = () => {
  const { merchantId, isMerchantLoading } = useOutletContext();

  const {
    data,
    isLoading,
    isError: isKycError,
  } = useBusinessKyc(merchantId, !!merchantId);

  if (isMerchantLoading) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <CircularProgress size={16} thickness={4} />
        <Typography variant="body2" color="text.secondary">
          Loading...
        </Typography>
      </Box>
    );
  }

  if (!merchantId) {
    return <CustomErrorMessage message="No merchant ID for this user" />;
  }

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <CircularProgress size={16} thickness={4} />
        <Typography variant="body2" color="text.secondary">
          Loading KYC details...
        </Typography>
      </Box>
    );
  }

  return (
    <SectionRoot>
      <Card>
        {isKycError ? (
          <CustomErrorMessage message="KYC information not found for this merchant." />
        ) : (
          <>
            <KycBusinessInfo d={data} />
            <Divider />
            <KycContact d={data} />
            <Divider />
            <KycOnline />
            <Divider />
            <KycBusinessAccount d={data} />
            <Divider />
            <KycDocuments d={data} />
          </>
        )}

        <Divider />
        <KycDirectorInfo directors={data?.directors ?? []} />
      </Card>
    </SectionRoot>
  );
};

export default Kyc;
